import { ChakraProvider, CSSReset } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import { ApiProvider, AuthProvider, Fonts, pwccAppTheme } from '@pwcc/common-components';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import UnavailablePage from './components/UnavailablePage';
import { apiClient, auth } from './config/apiClient';
import { RECAPTCHA_KEY } from './config/env';
import { styles } from './config/globalStyles';
import { ExternalLoginContextProvider } from './context/ExternalLoginContext';

export const App = () => {
  return (
    <ExternalLoginContextProvider value={{}}>
      <AuthProvider value={auth}>
        <ApiProvider value={apiClient}>
          <GoogleReCaptchaProvider
            useEnterprise
            reCaptchaKey={RECAPTCHA_KEY}
            container={{ parameters: { badge: 'bottomleft' } }}
          >
            <ChakraProvider theme={pwccAppTheme}>
              <CSSReset />
              <Global styles={styles} />
              <Fonts />
              <UnavailablePage />
            </ChakraProvider>
          </GoogleReCaptchaProvider>
        </ApiProvider>
      </AuthProvider>
    </ExternalLoginContextProvider>
  );
};
